export interface StudentDetails {
  name: string;
  phone: string;
}

const STUDENT_NAME_PATTERN = /^[\p{L}\p{M}](?:[\p{L}\p{M}'’ -]*[\p{L}\p{M}])?$/u;
const STUDENT_PHONE_PATTERN = /^\+?[\d\s().-]+$/;

export const normalizeStudentName = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const normalized = value.normalize('NFKC').trim().replace(/\s+/g, ' ');
  if (normalized.length < 2 || normalized.length > 80 || !STUDENT_NAME_PATTERN.test(normalized)) {
    return null;
  }

  return normalized;
};

export const normalizeStudentPhone = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const normalized = value.normalize('NFKC').trim();
  if (normalized.length < 7 || normalized.length > 30 || !STUDENT_PHONE_PATTERN.test(normalized)) {
    return null;
  }

  const digits = normalized.replace(/\D/g, '');
  if (digits.length < 7 || digits.length > 15) return null;

  return normalized.startsWith('+') ? `+${digits}` : digits;
};
